// extracted by css-extract-rspack-plugin
export default {"sectionLoader":"_fb92110b","sectionLoaderContent":"_e0006282","shimmerLoadingBackground":"_84386f5e","pricingSectionLoader":"_ca7d0c83"};